import React from 'react';

const adfox = {
  initScript: <script src="https://yastatic.net/pcode/adfox/loader.js" crossOrigin="anonymous" />,
  allDevices: {
    containerIds: ['adfox_157493188823236967'],
    initCode: () => {
      window.Ya.adfoxCode.create({
        ownerId: 237927,
        containerId: 'adfox_157493188823236967',
        params: {
          p1: 'bskdx',
          p2: 'fdye',
        },
      });
    },
  },
  desktop: {
    containerIds: ['banner_157062978250993178'],
    initCode: () => {
      window.Ya.adfoxCode.createAdaptive(
        {
          ownerId: 237927,
          containerId: 'banner_157062978250993178',
          params: {
            pp: 'srb',
            ps: 'cawq',
            p2: 'fdvt',
          },
        },
        ['desktop', 'tablet'],
        {
          tabletWidth: 830,
          phoneWidth: 480,
          isAutoReloads: false,
        },
      );
    },
  },
  phone: {
    containerIds: ['banner_157062996361225929'],
    initCode: () => {
      window.Ya.adfoxCode.createAdaptive(
        {
          ownerId: 237927,
          containerId: 'banner_157062996361225929',
          params: {
            pp: 'srb',
            ps: 'cawq',
            p2: 'fusv',
          },
        },
        ['phone'],
        {
          tabletWidth: 830,
          phoneWidth: 480,
          isAutoReloads: false,
        },
      );
    },
  },
};

export default adfox;
